import { createTheme, ThemeProvider as MuiThemeProvider } from '@mui/material';
import React from 'react';

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
    unit: 'px',
  },
  palette: {
    common: {
      black: '#000000',
      white: '#FFFFFF',
    },
    primary: {
      main: '#FFB900',
    },

    secondary: {
      main: '#3C464B',
    },
    info: {
      main: '#EAEBEB',
    },
    action: {
      active: '#000',
      hover: '#EEEEEE',
    },
    error: {
      main: '#CC0000',
      dark: '#CC0000',
      light: '#CC0000',
      contrastText: '#000',
    },
    grey: {
      300: '#EAEBEB',
      700: '#3C464B',
    },
    success: {
      main: '#86afaa',
      contrastText: '#000',
    },
    contrastThreshold: 3,
    tonalOffset: 0.2,
    background: {
      paper: '#FFFFFF',
      default: '#E0E4E8',
    },
  },
  shape: {
    borderRadius: 4,
  },

  typography: {
    fontFamily: 'JHFontNormal',
    fontSize: 13,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    h2: {
      fontWeight: 700,
      fontSize: '2rem',
    },
    h3: {
      fontWeight: 600,
      fontSize: '1.5rem',
    },
    h4: {
      fontWeight: 600,
      fontSize: '1.0rem',
    },
    h5: {
      fontSize: '0.75rem',
    },
    h6: {
      fontSize: '0.9rem',
    },
    subtitle2: {
      fontWeight: 700,
      fontSize: '0.75rem',
    },
    caption: {
      fontSize: '0.75rem',
    },
    headlineVehicle: {
      fontWeight: 900,
      fontSize: '2rem',
      fontFamily: 'slab-normal',
    },
    headlineVehicleSmall: {
      fontWeight: 900,
      fontSize: '1.1rem',
      fontFamily: 'slab-normal',
    },
    headlineDetailSection: {
      fontWeight: 600,
      fontSize: '1.4rem',
    },
    detailLabel: {
      fontWeight: 600,
      fontSize: '0.7rem',
      color: '#B9BDC1',
      textTransform: 'uppercase',
    },
    buttonActionHeadline: {
      fontWeight: 600,
      fontSize: '1rem',
      textTransform: 'uppercase',
    },
    detailText: { fontWeight: 600, fontSize: '1.1rem' },
    detailSubText: {
      fontWeight: 600,
      fontSize: '0.6rem',
    },
  },
  components: {
    MuiInputBase: {
      styleOverrides: {
        input: {
          borderRadius: 0,
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {},
      },
    },
  },
});

const overrideSidebar = {
  sidebar: {
    width: 325,
    closedWidth: 0,
  },
};

export const jhTheme = { ...theme, ...overrideSidebar };

// add custom typographys
declare module '@mui/material/styles' {
  interface TypographyVariants {
    headlineVehicle: React.CSSProperties;
    headlineVehicleSmall: React.CSSProperties;
    headlineDetailSection: React.CSSProperties;
    detailLabel: React.CSSProperties;
    detailText: React.CSSProperties;
    detailSubText: React.CSSProperties;
    buttonActionHeadline: React.CSSProperties;
  }

  // allow configuration using `createTheme`
  interface TypographyVariantsOptions {
    headlineVehicle?: React.CSSProperties;
    headlineVehicleSmall: React.CSSProperties;
    headlineDetailSection?: React.CSSProperties;
    detailLabel: React.CSSProperties;
    detailText: React.CSSProperties;
    detailSubText: React.CSSProperties;
    buttonActionHeadline: React.CSSProperties;
  }
}

// Update the Typography's variant prop options
declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    headlineVehicle: true;
    headlineDetailSection: true;
    detailLabel: true;
    detailText: true;
    detailSubText: true;
    headlineVehicleSmall: true;
    buttonActionHeadline: true;
  }
}

const ThemeProvider = (props: any) => {
  const { children } = props;

  return <MuiThemeProvider theme={jhTheme}>{children}</MuiThemeProvider>;
};

export default ThemeProvider;
